const options = {
  meal: "Meal Guide",
  supplement: "Supplement Guide",
  both: "Guides",
};
const Guides = (app) => {
  app
    .post("/guides/save", async ({ api, flash, req, res }) => {
      const { body, files } = req;
      let meal = false;
      let supplement = false;
      Object.keys(files).forEach((file) => {
        if (file === "meal-file") {
          meal = true;
        }
        if (file === "supplement-file") {
          supplement = true;
        }
      });
      const documentsUploaded =
        meal && supplement ? "both" : meal ? "meal" : "supplement";
      const saveGuides = await api(`athlete-guides`, {
        method: "POST",
        body,
        files,
      });
      flash("success", `${options[documentsUploaded]} saved successfully`);
      res.backDontScroll();
    })
    .post("/guides/remove", async ({ api, assert, flash, req, res }) => {
      const { body } = req;
      const { athleteId, type } = body;
      await api(`athlete-guides?athleteId=${athleteId}&type=${type}`, {
        method: "DELETE",
      }).then((res) => console.log("res==", res));

      flash("success", `Successfully deleted`);
      res.backDontScroll();
    });
};

export default Guides;
